<template>
  <div class="checkin-page" v-if="order">
    <!-- tab step -->
    <div class="tab-step">
      <div class="list-tab">
        <div @click="changeBoatOrderStatus(button, status)" class="each-tab"
             :style="{opacity: status === 'available' ? 1 : 0.5}"
             :key="button"
             v-for="(status, button) in order['action_buttons']">
          <div :class="{ 'tab-active': currentStep === button }" class="text-tab">
            {{replaceActionButton(capitalizeFirstLetter(button.replaceAll('_', ' ')))}}
          </div>
          <div v-if="button !== 'cancel'"
               class="line-tab line-tab-active"
          ></div>
        </div>
      </div>
      <div class="line-list" :class="[`bg-line-step-${currentStep}`]"></div>
    </div>

    <!-- main content  -->
    <div class="main-step">
      <StepCheckClient
        v-show="currentStep === BOAT_STATUS_UPDATE.PRE_CHECK"
        :title="'Pre departure checklist'"
        :listNotes="preCheckList"
        :isViewOnly="is_view"
        :status="currentStep"
        ref="refClientPreCheckList"
        @onSave="performPreCheckSubmit"
      ></StepCheckClient>
      <StepCheckClient
        v-show="currentStep === BOAT_STATUS_UPDATE.DESK_CHECK_IN"
        :title="'Please read, check and sign'"
        :isViewOnly="is_view"
        :status="currentStep"
        :listNotes="checkoutAgreementList"
        :signed-signature="signedSignature"
        ref="refClientDeckCheckIn"
        @onSave="performDeskCheckin"
      ></StepCheckClient>
      <StepAddOnes v-show="currentStep === BOAT_STATUS_UPDATE.ADD_ONS"
        :items="addOns"
        :isViewOnly="is_view"
          @updateAddOns="updateAddOns"
          @save="performSaveAddOns"
      ></StepAddOnes>
      <StepDepartureAndReturn :title="'Departure'"
          :boatWaterEquipment="extraBoatWaterEquipment"
          :boatNormalEquipment="extraBoatNormalEquipment"
          :boat-extra-items="order.order_info.boat_extras"
          :extra-id-values-item="extraIdValues"
          :status="currentStep"
          :isViewOnly="is_view"
          :markingLists="checkoutMarkingsList"
          :order-boat-id="order.order_info.boat_id"
          :checkout-boats-list="order.available_boats"
          :definedCheckoutImagesList="definedCheckoutImagesList"
          :checkout-markings-list-items="checkoutMarkingsList"
          :checkin-markings-list-items="checkinMarkingsList"
          :boat="order.boat_info"
          :signed-signature="signedSignature"
          :action-buttons="order['action_buttons']"
          @reload="loadOrderInfo()"
          ref="refClientDeparture"
          v-show="currentStep === BOAT_STATUS_UPDATE.CHECKOUT"></StepDepartureAndReturn>
      <StepDepartureAndReturn :title="'Return'"
          :boatWaterEquipment="extraBoatWaterEquipment"
          :boatNormalEquipment="extraBoatNormalEquipment"
          :boat-extra-items="order.order_info.boat_extras"
          :extra-id-values-item="extraIdValues"
          :status="currentStep"
          :isViewOnly="is_view"
          :markingLists="checkoutMarkingsList"
          :order-boat-id="order.order_info.boat_id"
          :checkout-boats-list="order.available_boats"
          :definedCheckoutImagesList="definedCheckoutImagesList"
          :checkout-markings-list-items="checkoutMarkingsList"
          :checkin-markings-list-items="checkinMarkingsList"
          :boat="order.boat_info"
          :action-buttons="order['action_buttons']"
          ref="refClientReturn"
          @reload="loadOrderInfo()"
          v-show="currentStep === BOAT_STATUS_UPDATE.CHECKIN"></StepDepartureAndReturn>
    </div>
  </div>
</template>

<script>
import StepCheckClient from "./StepCheckIn/StepCheckClient";
import StepAddOnes from "./StepCheckIn/StepAddOnes";
import StepDepartureAndReturn from './StepCheckIn/StepDepartureAndReturn.vue'
import {EventBus} from "@/utils/event-bus";
import DibbleAPI from "@/api";
import DibbleJS from "@/dibble";
import DibbleApi from "@/api";

const BOAT_STATUS_UPDATE = {
  PRE_CHECK: 'pre_check',
  ADD_ONS: 'add_ons',
  ON_RENT: "1",
  DONE: "2",
  LATE: "3",
  CHECKOUT: 'check_out',
  CHECKIN: 'check_in',
  CANCELLED: "cancel",
  DESK_CHECK_IN: 'desk_check_in'
}


export default {
  name: "checkInPage",
  data() {
    return {
      DibbleJS: DibbleJS,
      BOAT_STATUS_UPDATE: BOAT_STATUS_UPDATE,
      orderId: this.$route.params.id,
      order: null,
      is_view: false,
      formDirty: false,
      currentStep: BOAT_STATUS_UPDATE.PRE_CHECK,
      preCheckList: [],
      checkoutAgreementList: [],
      checkoutMarkingsList: [],
      checkinMarkingsList: [],
      definedCheckoutImagesList: [],
      boatExtras: [],
      extraIdValues: [],
      addOns: [],
      checkInManagerCode: '',
      checkinExcessAmount: ''
    };
  },
  components: {
    StepCheckClient,
    StepAddOnes,
    StepDepartureAndReturn
  },
  computed: {
    signedSignature() {
      switch (this.currentStep) {
        case BOAT_STATUS_UPDATE.DESK_CHECK_IN:
          return this.order && this.order.order_info['desk_signature'].indexOf('png') > -1 ? this.order['order_info']['desk_signature'] : null
        
        case BOAT_STATUS_UPDATE.CHECKOUT : {
          return this.order && this.order.order_info['checkout_signature'].indexOf('png') > -1 ? this.order['order_info']['checkout_signature'] : null
        }

        case BOAT_STATUS_UPDATE.CHECKIN : {
          return this.order && this.order.order_info['checkin_signature'].indexOf('png') > -1 ? this.order['order_info']['checkin_signature'] : null
        }
      }

      return null
    },
    extraBoatWaterEquipment() {
      return this.boatExtras.filter(b=> b.is_water_sport_equipment)
    },
    extraBoatNormalEquipment() {
      return this.boatExtras.filter(b=> !b.is_water_sport_equipment)
    },
  },
  created() {
    EventBus.$emit("currentViewOrderId", this.orderId);
    this.loadOrderInfo();
  },
  watch: {
    currentStep() {
      if (this.currentStep === BOAT_STATUS_UPDATE.PRE_CHECK || this.currentStep === BOAT_STATUS_UPDATE.DESK_CHECK_IN) {
        this.$refs.refClientPreCheckList.reset();
        this.$refs.refClientDeckCheckIn.reset();
      }
    }
  },
  methods: {
    replaceActionButton(buttonAlias) {
      switch (buttonAlias.toLowerCase()) {
        case 'desk check in': {
          return 'Client checklist'
        }
        case 'check out': {
          return 'Departure'
        }
        case 'check in': {
          return 'Return'
        }
        case 'cancel': {
          return 'Cancel order'
        }
        default: return buttonAlias
      }
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    changeTab(tabValue) {
      this.currentStep = tabValue;
    },
    changeBoatOrderStatus(button, status) {
      if (status !== 'not_available') {
        if (button === BOAT_STATUS_UPDATE.CANCELLED) {
          this.cancelRentalBoat(0)
        } else {
          this.changeTab(button)  
          let foundAvailableStatus = false
          for (const idx in BOAT_STATUS_UPDATE) {
            if (BOAT_STATUS_UPDATE[idx] === button) {
              foundAvailableStatus = true
              break
            }
          }

          if (foundAvailableStatus) {
            this.currentStateForBoatId = 0
            this.is_view = status !== 'available';
            
            switch (this.currentStep) {
              case BOAT_STATUS_UPDATE.CHECKOUT: {
                console.log('case 1');
                this.$refs.refClientDeparture.initElements(this.currentStep);
                break
              }
              case BOAT_STATUS_UPDATE.CHECKIN: {
                console.log('case 2');
                this.$refs.refClientReturn.initElements(this.currentStep);
                break
              }
            }
          }
        }
      }
    },
    loadOrderInfo() {
      const params = {
        request: DibbleAPI.api.adminGetRentalBoatOrder,
        order_id: this.orderId
      }
      DibbleJS.showLoader();
      DibbleJS.callApiRequest(params, this._onLoadOrderSuccess, this._onLoadOrderFailed)
    },
    _onLoadOrderSuccess(response) {
      DibbleJS.hideLoader();
      if (DibbleApi.isResponseSuccess(response)) {
        this.order = this.orderOrigin = response;
        this.onGetRentalBoatExtras();
        this.checkinMarkingsList = []
        if (typeof this.order['order_info']['checkout_marking_images'] !== 'undefined') {
          for (const i in this.order['order_info']['checkout_marking_images']) {
            this.checkinMarkingsList.push({
              name: i,
              image_url: this.order['order_info']['checkout_marking_images'][i],
              markers: []
            })
          }
        }
        this.changeBoatOrderStatus(this.currentStep, this.order['action_buttons'][this.currentStep])
      } else {
        DibbleJS.toastErrorMessage(response.message)
      }
    },
    onGetRentalBoatExtras(){
      const params = {
        request: DibbleAPI.api.getRentalBoatExtras,
        order_id: this.orderId
      }
      DibbleJS.callApiRequest(params, this._onBoatExtrasSuccess)
    },

    _onBoatExtrasSuccess(response){
      if (DibbleApi.isResponseSuccess(response)) {
        const { add_ons, boat_extras, checkout_images_list, cart_items } = response
        this.boatExtras = boat_extras
        this.definedCheckoutImagesList = checkout_images_list
        for (let i in this.boatExtras) {
          this.extraIdValues.push({
            id: this.boatExtras[i].boat_extra_id,
            value: this.boatExtras[i].default_amount ? '' : false,
            amount: this.boatExtras[i].price,
            type: this.boatExtras[i].type
          })
        }

        this.cartItems = cart_items
        this.addOns = add_ons
        this.preCheckList = response['precheck_list']
        this.checkoutAgreementList = response['client_checkout_list']
        this.checkoutMarkingsList = response['checkout_markings_list']
        if (this.checkoutMarkingsList) {
          for (const i in this.checkoutMarkingsList) {
            this.checkoutMarkingsList[i]['markers'] = []
          }
        }
      } else {
        DibbleJS.toastErrorMessage(response.message)
      }
    },
    cancelRentalBoat(boatId) {
      DibbleJS.confirmBox('Are you sure you want to cancel this order boat?', () => {
        DibbleJS.showLoader()
        DibbleJS.callApiRequest({
          request: DibbleApi.api.cancelRentalBoat,
          order_id: this.orderId,
          boat_id: boatId,
        }, response => {
          DibbleJS.hideLoader();
          if (DibbleApi.isResponseSuccess(response)) {
            DibbleJS.toastSuccessMessage(response.message)
            this.loadOrderInfo()
          } else {
            DibbleJS.toastErrorMessage(response.message)
          }
        })
      })
    },
    performPreCheckSubmit() {
      const params = {
        request: DibbleAPI.api.rentalCompletePreCheck,
        order_id: this.orderId
      };

      DibbleJS.showLoader()
      DibbleJS.callApiRequest(params, (response) => {
        DibbleJS.hideLoader();
        if (DibbleApi.isResponseSuccess(response)) {
          DibbleJS.toastSuccessMessage(response.message)
          this.loadOrderInfo()
        } else {
          DibbleJS.toastErrorMessage(response.message)
        }
      })
    },
    performDeskCheckin() {
      const isEmptySignatureSet = this.saveSignature();
      if (isEmptySignatureSet) {
        DibbleJS.toastErrorMessage('Please draw your signature');
        return;
      }

      const params = {
        request: DibbleAPI.api.rentalSaveDeskCheckingSignature,
        order_id: this.orderId,
        client_signature: this.clientSignature
      };

      DibbleJS.showLoader()
      DibbleJS.callApiRequest(params, this._onSaveDeskCheckingSignatureSuccess)
    },
    _onSaveDeskCheckingSignatureSuccess(response) {
      DibbleJS.hideLoader();
      if (DibbleApi.isResponseSuccess(response)) {
        DibbleJS.toastSuccessMessage(response.message)
        this.loadOrderInfo()
      } else {
        DibbleJS.toastErrorMessage(response.message)
      }
    },
    clearSignature() {
      this.$refs.signaturePad.clearSignature();
    },
    saveSignature() {
      const { isEmpty, data } = this.$refs.refClientDeckCheckIn.$refs.signaturePad.saveSignature();
      if (!isEmpty) {
        this.clientSignature = data;
      }

      return isEmpty;
    },
    showDamageMarkingModal(image) {
      this.formDirty = true
      this.$emit('modalListener', {
        action: 'showDamageMarkingModal',
        data: {
          image: image,
          status: this.currentUpdateStatus
        }
      })
    },
    onBegin() {
      this.$refs.signaturePad.resizeCanvas()
    },
    onTouchMove(event){
      event.preventDefault()
      event.stopPropagation();
    },
    updateAddOns(addOns) {
      this.addOns = addOns
    },
    performSaveAddOns () {
      const addOns = []
      for (const i in this.addOns) {
        let addOn = null
        if (this.addOns[i].default_amount) {
          if (this.addOns[i]?.amount && parseInt(this.addOns[i].amount)) {
            addOn = {
              boat_extra_id: this.addOns[i].boat_extra_id,
              amount: this.addOns[i].amount
            }
          }
        } else if (this.addOns[i].amount) {
          addOn = {
            boat_extra_id: this.addOns[i].boat_extra_id,
            amount: 1
          }
        }

        if (addOn) {
          addOns.push(addOn)
        }
      }

      const data = {action: 'saveAddOns', params: {add_ons: addOns}};
      DibbleJS.showLoader();
      const params = {...data.params};
      params.request = DibbleApi.api.setRentalBoatAddOns
      params.order_id = this.$route.params.id

      DibbleJS.callApiRequest(params, (response) => {
        DibbleJS.hideLoader();
        if (DibbleAPI.isResponseSuccess(response)) {
          this.isShowModal = false
          DibbleJS.toastSuccessMessage(response.message)
          this.loadOrderInfo()
        } else {
          DibbleJS.toastErrorMessage(response.message)
        }
      }, this._onLoadOrderFailed)
    },
    _onLoadOrderFailed() {
      DibbleJS.hideLoader();
      DibbleJS.toastErrorMessage('Something wrong! can not load data');
    },
  },
};
</script>

<style lang="scss" scoped>
.checkin-page {
  margin: 20px 70px;
  display: flex;
  flex-direction: column;
  min-height: 85vh;
  background: #f3f6f7;
  box-shadow: 0px 15px 20px -6px rgba(16, 24, 40, 0.15);
  border-radius: 40px;
  min-width: 1000px;
  .tab-step {
    height: max-content;
    padding: 20px 20px 0px;
  }
  .list-tab {
    display: flex;
    width: 100%;
    justify-content: space-around;
    min-width: 1000px;
    .each-tab {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      user-select: none;
    }
    .text-tab {
      background: #eaeaea;
      box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
      border-radius: 40px;
      width: 150px;
      max-width: 150px;
      height: 95px;
      font-family: "Open Sans";
      font-style: normal;
      font-weight: 600;
      font-size: 22px;
      line-height: 26px;
      color: #c4c4c5;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      padding: 20px;
    }
    .line-tab {
      height: 28px;
      width: 1.5px;
      background: #c4c4c5;
    }
  }
  .line-list {
    height: 10px;
    border-radius: 6px;
    transform: rotate(180deg);
    user-select: none;
  }
}
.main-step {
  padding: 25px 20px 20px;
}
.tab-active {
  background: #2c94ab !important;
  color: #ffffff !important;
}
.line-tab-active {
  background: #2c94ab !important;
}
.bg-line-step-pre_check {
  background: linear-gradient(90deg, #e8eff1 78.65%, #2c94ab 100%);
}
.bg-line-step-desk_check_in {
  background: linear-gradient(90deg, #e8eff1 50%, #2c94ab 100%);
}
.bg-line-step-add_ons {
  background: linear-gradient(90deg, #e8eff1 29.17%, #2c94ab 100%);
}
.bg-line-step-check_out {
  background: linear-gradient(90deg, #e8eff1 7.81%, #2c94ab 100%);
}
.bg-line-step-check_in {
  background: linear-gradient(90deg, #2c94ab 0%, #2c94ab 100%);
}
</style>
